import { useEffect } from "react";
import UnexpectedError from "./UnexpectedError";
import { useGlobalStore } from "@/GlobalStore";
import { useReportCache } from "@/screens/creatives/hooks/useReportCache";

const ErrorCard = ({
  error,
}: {
  error: unknown;
  componentStack: string;
  eventId: string;
  resetError: () => void;
}) => {
  const { selectedAccount } = useGlobalStore();
  const { clearCacheForAccount } = useReportCache();
  // Reload logic for import module errors
  const reloadCount = parseInt(sessionStorage.getItem("reloadCount") || "0");
  const errorMessage = (error as Error)?.message || JSON.stringify(error);
  const hasImportError = errorMessage
    .toLowerCase()
    .includes("failed to fetch dynamically imported module");

  useEffect(() => {
    if (hasImportError && reloadCount < 2) {
      // Allow max 2 reload attempts - increment and reload
      sessionStorage.setItem("reloadCount", (reloadCount + 1).toString());
      window.location.reload();
      // Don't execute anything after reload
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  useEffect(() => {
    if (selectedAccount && !hasImportError) {
      void clearCacheForAccount(selectedAccount.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAccount?.id]);

  // Cleanup: remove reload count on component unmount
  useEffect(() => {
    return () => {
      sessionStorage.removeItem("reloadCount");
    };
  }, []);

  // Handle import errors with reload logic
  if (hasImportError) {
    // Show error message after max reload attempts (reloadCount >= 2)
    // Otherwise show blank screen during reload
    if (reloadCount >= 2) {
      return <UnexpectedError />;
    }
    return <></>;
  }

  // Default case - pass all props to UnexpectedError
  return <UnexpectedError />;
};

export default ErrorCard;
